
import { getRequest, postRequest } from '../tools/ajax.js'

//所有案件类型
const CaseType = params => postRequest('/api/pc/Option/CaseType', params);

// 查询
const Case = params => postRequest('/api/pc/Examine/ExamineCase', params);

//详情
const Detail= params => postRequest('/api/pc/Examine/CaseDetail', params);

//案件冲突
const Conflict = params => postRequest('/api/pc/Option/CaseConflict', params);

//顾问冲突
const AdviserConflict = params => postRequest('/api/pc/Option/AdviserConflict', params);


//驳回
const Reject= params => postRequest('/api/pc/Examine/CaseReject', params);

//审核通过
const Success= params => postRequest('/api/pc/Examine/CaseSuccess', params);

// 用章审核 查询
const Seal= params => postRequest('/api/pc/Examine/ExamineSeal', params);

// 用章审核 详情
const SealDetail= params => postRequest('/api/pc/Examine/SealDetail', params);

// 用章审核通过
const SealSuccess= params => postRequest('/api/pc/Examine/SealSuccess', params);


// 用章审核不通过
const SealReject= params => postRequest('/api/pc/Examine/SealReject', params);

// 投标审核 查询
const Tender= params => postRequest('/api/pc/Examine/ExamineTender', params);

// 投标审核 详情
const TenderDetail= params => postRequest('/api/pc/Examine/TenderDetail', params);

// 投标审核 通过
const TenderSuccess= params => postRequest('/api/pc/Examine/TenderSuccess', params);

// 投标审核 不通过
const TenderReject= params => postRequest('/api/pc/Examine/TenderReject', params);


// 案件已审核
const CaseRecord= params => postRequest('/api/pc/Examine/CaseRecord', params);

export {
    CaseType,Case,Detail,Conflict,AdviserConflict,Reject,Success,
    Seal,SealDetail,SealSuccess,SealReject,
    Tender,TenderDetail,TenderSuccess,TenderReject,CaseRecord
}
// export function SealApply(data) {
//     return request({
//       url: '/api/Seal/SealApply',
//       method: 'post',
//       data
//     })
//   }